import Box, { type BoxProps } from '@mui/material/Box'
import React from 'react'

type TabPanelProps = BoxProps & {
  value: number | string
  index: number | string
  reRender?: boolean
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, className = '', reRender = false, ...rest }) => (
  <Box className={className} hidden={value !== index} role="tabpanel" {...rest}>
    {!reRender && children}
    {reRender && value === index && children}
  </Box>
)

export default TabPanel
